<template>
	<div class="content-class">
		<v-tabs v-model="active" color="black" dark slider-color="primary">
			<v-tab :key="'userLists'" ripple>Liste d'envoi</v-tab>
			<v-tab :key="'schedule'" ripple>Programmer</v-tab>
			<v-tab :key="'subBot'" ripple>Logs</v-tab>

			<v-tab-item :key="'userLists'">
				<user-list-form v-model="document"> </user-list-form>

				<v-btn @click="remove" color="error">Supprimer</v-btn>

				<user-list
					ref="userList"
					:url="
						'users?filter=bots.bot:$eq:' + $route.params.botId + ';userLists:$elemMatch:$eq:' + $route.params.userListId
					"
					:added-items="deleteUser"
				>
				</user-list>

				<user-list
					ref="userListNot"
					:url="
						'users?filter=bots.bot:$eq:' +
							$route.params.botId +
							';userLists:$nElemMatch:$eq:' +
							$route.params.userListId
					"
					:added-items="addUser"
				>
				</user-list>
			</v-tab-item>

			<v-tab-item :key="'schedule'">
				<send-sub-bot :params="{ id: $route.params.userListId }" :schedules="document ? document.schedules : null" />
			</v-tab-item>

			<v-tab-item :key="'Logs'">
				<log-list
					:url="'logs?filter=references.reference:$eq:userLists;references.referenceId:$eq:' + $route.params.userListId"
				>
				</log-list>
			</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>
import sendSubBot from '../../components/modals/sendSubBot'
import UserListForm from '../../components/userLists/userList.form'
import LogList from '../../components/logs/log.list.vue'
import UserList from '../../components/users/user.list'

import { ERROR, SUCCESS } from '../../variables'

export default {
	components: { UserList, UserListForm, LogList, sendSubBot },
	methods: {
		remove() {
			this.axios
				.delete('userLists/' + this.$route.params.userListId)
				.then((response) => {
					this.$store.dispatch(SUCCESS, "Liste d'envoi supprimé")
					this.$router.push({ name: 'UserListList', params: { botId: this.$route.params.userListId } })
				})
				.catch((err) => {
					this.$store.dispatch(ERROR, err)
				})
		},
	},
	data() {
		return {
			active: null,
			document: null,
			addUser: [
				{
					header: 'Ajouter',
					icon: () => 'add',
					cellClick: (item) => {
						this.axios
							.post('userLists/' + this.$route.params.userListId + '/users/' + item._id)
							.then((response) => {
								this.$store.dispatch(SUCCESS, "Utilisateur ajouté à la liste d'envoi")
								this.$refs.userList.update()
								this.$refs.userListNot.update()
							})
							.catch((err) => {
								this.$store.dispatch(ERROR, err)
							})
					},
				},
			],
			deleteUser: [
				{
					header: 'Supprimer',
					icon: () => 'delete',
					cellClick: (item) => {
						this.axios
							.delete('userLists/' + this.$route.params.userListId + '/users/' + item._id)
							.then((response) => {
								this.$store.dispatch(SUCCESS, "Utilisateur supprimé de la liste d'envoi")
								this.$refs.userList.update()
								this.$refs.userListNot.update()
							})
							.catch((err) => {
								this.$store.dispatch(ERROR, err)
							})
					},
				},
			],
		}
	},
	mounted() {
		this.axios
			.get('userLists/' + this.$route.params.userListId)
			.then((response) => {
				this.document = response.data
			})
			.catch((err) => {
				this.$store.dispatch(ERROR, err)
			})
	},
}
</script>

<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/userLists/userList.detail.vue